<template>
  <div class="analysis">
    <div class="title">
      <span>考勤统计</span>
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <mu-form-item label="姓名" label-position="left">
        <mu-select v-model="form.userId" @change="getAll" style="width: 150px">
          <mu-option
            v-for="(item, index) in userList"
            :key="index"
            :label="item.realName"
            :value="item.id"
          ></mu-option>
        </mu-select>
      </mu-form-item>
      <mu-form-item
        label="年"
        label-position="left"
        style="margin-left: 50px"
        label-width="30"
      >
        <mu-select v-model="form.year" style="width: 120px" @change="getAll">
          <mu-option
            v-for="(item, index) in yearList"
            :key="index"
            :label="item"
            :value="item"
          ></mu-option>
        </mu-select>
      </mu-form-item>
      <mu-form-item label="月" label-position="left" label-width="30">
        <mu-select v-model="form.month" style="width: 120px" @change="getAll">
          <mu-option
            v-for="(item, index) in monthList"
            :key="index"
            :label="item"
            :value="item"
          ></mu-option>
        </mu-select>
      </mu-form-item>
      <div class="info">
        出勤<span>{{ info.count }}</span
        >班次，加班<span>{{ info.overtimeCount }}</span
        >次共<span>{{ info.overtimeHour }}</span
        >小时，迟到<span>{{ info.delayCount }}</span
        >次共<span>{{ info.delayMinute }}</span
        >分钟，早退<span>{{ info.advanceCount }}</span
        >次共<span>{{ info.advanceMinute }}</span
        >分钟
      </div>
    </mu-form>
    <mu-paper :z-depth="1" class="paper">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
        border
        :height="tableHeight"
      >
        <template slot="header" slot-scope="scope">
          <tr>
            <th rowspan="2" class="is-center">日期</th>
            <th
              colspan="2"
              v-for="(item, index) in scheduleList"
              :key="index"
              class="is-center"
            >
              {{ item.name }} {{ item.startTime }} - {{ item.endTime }}
            </th>
          </tr>
          <tr>
            <th
              class="is-center"
              v-for="(item, index) in scope.columns.filter(
                (item, index) => index > 0
              )"
              :key="index"
            >
              {{ item.title }}
            </th>
          </tr>
        </template>
        <template slot-scope="scope">
          <td>{{ scope.row.date }}</td>
          <td
            v-for="(item, index) in scope.row.attendance"
            :key="index"
            :class="item.second > 0 ? 'red' : ''"
          >
            <div class="time">
              {{ item.time }}
              <div class="tooltip" v-if="item.second > 0">
                {{ item.text }}{{ parseInt(item.second / 60) }}分钟
              </div>
            </div>
          </td>
        </template>
      </mu-data-table>
    </mu-paper>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      form: {
        userId: 0,
        year: moment().year(),
        month: moment().month() + 1
      },
      columns: [
        {
          title: '日期',
          name: 'date',
          align: 'center'
        }
      ],
      list: [],
      moment,
      scheduleList: [],
      userList: [],
      yearList: [],
      monthList: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
      ],
      tableHeight: window.innerHeight - 280,
      info: {
        count: 0,
        overtimeCount: 0,
        overtimeHour: 0,
        delayCount: 0,
        delayMinute: 0,
        advanceCount: 0,
        advanceMinute: 0
      }
    }
  },
  methods: {
    init() {
      for (let i = 2019; i <= moment().year(); i++) {
        this.yearList.push(i.toString())
      }
    },
    getAll() {
      this.loading = true
      backend(api.attendance.analysis, this.form).then((result) => {
        this.loading = false
        if (result.statusCode === 200 && result.data.length > 0) {
          this.info.count = result.data.filter(
            (x) => !x.schedule.isOvertime
          ).length
          this.info.overtimeCount = result.data.filter(
            (x) => x.schedule.isOvertime
          ).length
          // 加班时间计算
          if (this.info.overtimeCount > 0) {
            if (
              result.data.filter(
                (x) =>
                  x.schedule.isOvertime &&
                  x.endTime !== null &&
                  x.startTime !== null
              ).length > 0
            ) {
              this.info.overtimeHour = (
                result.data
                  .filter(
                    (x) =>
                      x.schedule.isOvertime &&
                      x.endTime !== null &&
                      x.startTime !== null
                  )
                  .map((x) =>
                    moment(x.endTime).diff(moment(x.startTime), 'seconds')
                  )
                  .reduce((a, b) => a + b) / 3600
              ).toFixed(2)
            } else {
              this.info.overtimeHour = 0
            }
          } else {
            this.info.overtimeHour = 0
          }
          this.info.delayCount = result.data.filter(
            (x) => x.delaySecond > 0
          ).length
          this.info.delayMinute = (
            result.data.map((x) => x.delaySecond).reduce((a, b) => a + b) / 60
          ).toFixed(2)
          this.info.advanceCount = result.data.filter(
            (x) => x.advanceSecond > 0
          ).length
          this.info.advanceMinute = (
            result.data.map((x) => x.advanceSecond).reduce((a, b) => a + b) / 60
          ).toFixed(2)
          const list = []
          const currentMonth = moment()
            .year(this.form.year)
            .month(this.form.month - 1)
          for (let i = 1; i <= currentMonth.daysInMonth(); i++) {
            const date = currentMonth.date(i).format('YYYY-MM-DD')
            const temp = {
              date: currentMonth.date(i).format('MM-DD'),
              attendance: []
            }
            this.scheduleList.forEach((schedule) => {
              const exist = result.data.find(
                (x) => x.schedule.id === schedule.id && x.date === date
              )
              temp.attendance.push({
                time:
                  exist && exist.startTime
                    ? moment(exist.startTime).format('HH:mm:ss')
                    : '',
                second: exist ? exist.delaySecond : 0,
                text: '迟到'
              })
              temp.attendance.push({
                time:
                  exist && exist.endTime
                    ? moment(exist.endTime).format('HH:mm:ss')
                    : '',
                second: exist ? exist.advanceSecond : 0,
                text: '早退'
              })
            })
            list.push(temp)
          }
          this.list = list
        }
      })
    },
    getAllSchedule() {
      backend(api.daka.getSchedule, { getAll: true, isUsing: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            // 按开始时间排序
            this.scheduleList = result.data.rows.sort(
              (a, b) =>
                Number(a.startTime.split(':')[0]) -
                Number(b.startTime.split(':')[0])
            )
            this.scheduleList.forEach((item) => {
              this.columns.push({
                title: '上班'
              })
              this.columns.push({
                title: '下班'
              })
            })
          }
        }
      )
    },
    getAllClerk() {
      backend(api.user.getAll, { getAll: true, isClerk: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.userList = result.data.rows
            this.form.userId = result.data.rows[0].id
            this.getAll()
          }
        }
      )
    }
  },
  mounted() {
    this.init()
    this.getAllSchedule()
    this.getAllClerk()
  }
}
</script>

<style lang="less" scoped>
.analysis {
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .form {
    position: relative;
    .info {
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 18px;
      span {
        color: #ff4081;
      }
    }
  }
  .paper {
    width: calc(100% - 1px);
    .table {
      td {
        text-align: center;
        overflow: initial;
        cursor: pointer;
        &.red {
          color: #ff4081;
        }
        .time {
          position: relative;
          .tooltip {
            position: absolute;
            bottom: 20px;
            width: 100px;
            text-align: center;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            color: #fff;
            left: 50%;
            margin-left: -50px;
            height: 0;
            overflow: hidden;
            transition: height 0.5s;
          }
        }
        &:hover {
          .time {
            .tooltip {
              height: 20px;
            }
          }
        }
      }
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/attendance/analysis.vue